<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">课程管理</Breadcrumb-item>
        <Breadcrumb-item>教材价格列表</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="btn-wrap">
      <Button type="primary" icon="plus-round" @click="onEdit">添加教材价格</Button>
    </div>
    <List style="margin-top: 20px" ref="dataList" :tableColumns="title" :reload="reload" listUrl="/materialPrice/listByPage"
          :params="queryParam" :onLoading="onLoading"></List>

    <Modal title="编辑教材价格" v-model="editModal">
      <Form ref="form" :model="formData" :rules="formRule" :label-width="80" style="overflow: visible">
        <Row>
          <i-col :span="22">
            <Form-item label="标题" prop="title">
              <Input v-model="formData.title" placeholder="必填"/>
            </Form-item>
          </i-col>
        </Row>
        <Row>
          <i-col :span="22">
            <Form-item label="教材价格" prop="price">
              <Input v-model.number="formData.price"/>
            </Form-item>
          </i-col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="editModal=false">取消</Button>
        <Button type="primary" size="large" :loading="loadingInsert" @click="edit">保存</Button>
      </div>
    </Modal>
  </div>

</template>
<script>

  export default {
    data () {
      let self = this
      return {
        searchLoading: false,
        reload: 0,
        queryParam: {
        },
        formData: {
          id: '',
          title: '',
          price: '',
        },
        formRule: {
          title: [
            {type: 'string', required: true, message: '标题不能为空', trigger: 'blur'}
          ],
          price: [
            {type: 'integer', required: true, message: '价格不能为空', trigger: 'blur'}
          ],
        },
        editModal: false,
        loadingInsert: false,
        title: [
          {
            title: 'ID',
            key: 'id',
            align: 'center',
          },
          {
            title: '标题',
            key: 'title',
            align: 'center',
          },
          {
            title: '价格',
            key: 'price',
            align: 'center',
          },
          {
            title: '操作',
            align: 'center',
            width: 100,
            render: (h, params) => {
              return h('div', [
                h('a', {on: {click: () => { self.onEdit(params.row) }}}, '编辑')
              ])
            }
          }
        ]
      }
    },
    mounted: function () {
    },
    created: function () {
    },
    methods: {
      search () {
        this.reload = new Date().getTime()
      },
      onLoading (loading) {
        this.searchLoading = loading
      },
      onEdit (row) {
        if (!row) {
          this.$helper.reset(this.formData)
          return
        }
        this.$helper.copyProperties(row, this.formData)
        this.editModal = true
      },
      edit () {
        let self = this
        self.$refs.form.validate((valid) => {
          if (valid) {
            let path = '/materialPrice/insert'
            self.$http.post(path, this.formData).then((res) => {
              if (res && res.data > 0) {
                self.$Message.success('提交成功!')
                self.editModal = false
                self.search()
              }
            })
          } else {
            self.$Message.warning('表单验证失败!')
          }
        })
      }
    },
    watch: {
      editModal (val) {
      }
    }
  }

</script>

<style lang="less" scoped>
  .btn-wrap {
    text-align: right;
    margin-top: 24px;
    margin-bottom: 12px;
  }
</style>


// WEBPACK FOOTER //
// CoursePriceList.vue?9b271880